export enum MedOrderMatchEnum {
  Schedule = 0,
  DualMatch = 1,
  JCode = 2,
  Gcn = 3,
  No = 4,
  Name = 5,
  Patient = 6,
  OncoEMRMedIdMatch = 7,
}
